import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from 'src/shared/components/ui/form'
import { Input } from 'src/shared/components/ui/input'

export const FormInput = ({
  name,
  label,
  description,
  methods,
  placeholder,
  startContent,
  endContent,
  disabled = false,
  readOnly = false,
  type = 'text',
  className = '',
  appendEndContent,
  autoComplete,
  onBlur,
}: {
  name: string
  label?: string | React.ReactNode
  description?: string
  methods: UseFormReturn<any>
  placeholder?: string
  startContent?: React.ReactNode
  endContent?: React.ReactNode
  disabled?: boolean
  readOnly?: boolean
  type?: string
  className?: string
  appendEndContent?: React.ReactNode
  autoComplete?: string
  onBlur?: () => void
}) => {
  return (
    <FormField
      control={methods.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormControl>
            <Input
              {...field}
              label={label}
              placeholder={placeholder}
              startContent={startContent}
              endContent={endContent}
              disabled={disabled}
              readOnly={readOnly}
              type={type}
              appendEndContent={appendEndContent}
              autoComplete={autoComplete}
              onBlur={() => {
                field.onBlur()
                onBlur?.()
              }}
            />
          </FormControl>

          {description && (
            <FormDescription className="text-xs text-muted-foreground">
              {description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
